import * as v from "valibot";

import { rpcContract } from "../rpc";

export const submitContactFormRpcContract = rpcContract({
  name: "submit-contact-form",
  paramsSchema: v.object({
    name: v.pipe(v.string(), v.minLength(1, "Name is required"), v.maxLength(254)),
    email: v.pipe(v.string(), v.email("Invalid email format"), v.maxLength(254)),
    phone: v.optional(v.pipe(v.string(), v.maxLength(64))),
    company: v.optional(v.pipe(v.string(), v.maxLength(254))),
    message: v.pipe(v.string(), v.minLength(1, "Message is required"), v.maxLength(5000)),
    pageUrl: v.pipe(v.string(), v.maxLength(2048)),
    // Honeypot — humans submit empty, automated form-fillers fill it. The
    // handler returns a successful response when it's non-empty so bots get
    // no signal to iterate against.
    website: v.optional(v.string()),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type SubmitContactFormParams = v.InferOutput<(typeof submitContactFormRpcContract)["paramsSchema"]>;
export type SubmitContactFormResult = v.InferOutput<(typeof submitContactFormRpcContract)["resultSchema"]>;
